import { render, staticRenderFns } from "./SectionLeft.vue?vue&type=template&id=b89682ec&scoped=true"
import script from "./SectionLeft.vue?vue&type=script&lang=js"
export * from "./SectionLeft.vue?vue&type=script&lang=js"
import style0 from "./SectionLeft.vue?vue&type=style&index=0&id=b89682ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89682ec",
  null
  
)

export default component.exports